import { useContext } from "react";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCancelReturn } from "./useCancelReturn";
import { useCheckAPI } from "../../hooks/useCheckAPI";
// MUI
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const NonReturnableDialog = ({
  returnData,
  setReturnData,
  setActiveStep,
}) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);
  const { mutate, isSuccess, data } = useCancelReturn();

  // Cancel Return
  const handleClose = () => {
    const no = returnData.data.data.returnOrder.no;
    mutate({
      data: { filter: { noFilter: no } },
    });
  };

  // Success Function
  const successFunc = () => {
    setReturnData({});
    setActiveStep(0);
  };

  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "warning",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Dialog
      open
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Items Not Eligible for Return"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          None of the items listed on this invoice qualify for return.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
